import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { GiftCardVisual } from "@/components/gift/GiftCardVisual";

const SAMPLE = {
  kind: "product", product_name: "Pacchetto 10 lezioni", recipient_name: "Giulia", buyer_name: "Marta",
  message: "Per il tuo compleanno: tempo per te, respiro e movimento.", code: "EPIC-GIFT-2026",
};

/** Promo Gift Card: home (variant="landing") e sopra i prodotti dell'area cliente (variant="shop"). */
export function GiftCardPromo({ variant = "landing" }) {
  const { user } = useAuth();
  const to = user?.role === "client" ? "/gift-card" : "/registrati?next=/gift-card";
  if (variant === "shop") {
    return (
      <div data-testid="gift-promo-shop"
        className="grid md:grid-cols-[minmax(0,380px)_1fr] gap-6 items-center rounded-3xl border border-primary/20 bg-primary/5 p-5 md:p-6">
        <GiftCardVisual card={{ ...SAMPLE, message: "" }} compact />
        <div className="space-y-3">
          <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-secondary">
            <Gift className="w-4 h-4" strokeWidth={1.5} /> Gift Card
          </div>
          <h3 className="font-serif-display text-2xl md:text-3xl leading-tight">Regala Epic Flow a chi ami</h3>
          <p className="text-sm text-muted-foreground">Un pacchetto, un abbonamento o un importo libero, con il tuo messaggio di auguri. La scarichi subito e la regali.</p>
          <Link to="/gift-card" data-testid="gift-promo-shop-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary text-primary-foreground text-xs uppercase tracking-widest transition-transform hover:-translate-y-0.5">
            <Gift className="w-4 h-4" /> Regala una Gift Card
          </Link>
        </div>
      </div>
    );
  }
  return (
    <section data-testid="landing-gift-card" className="bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid lg:grid-cols-2 gap-14 items-center">
        <div className="order-2 lg:order-1 flex justify-center">
          <div className="w-full max-w-[560px] transition-transform duration-500 hover:-rotate-1 hover:scale-[1.02]">
            <GiftCardVisual card={SAMPLE} />
          </div>
        </div>
        <div className="order-1 lg:order-2 space-y-6">
          <div className="text-[10px] uppercase tracking-[0.42em] text-secondary flex items-center gap-3">
            <span className="w-10 h-px bg-current opacity-60" /> Gift Card
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
            Il regalo che fa <span className="font-editorial">respirare</span>
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-lg font-light">
            Regala un pacchetto di lezioni, un abbonamento o un importo a tua scelta, con un messaggio di auguri personalizzato e un codice da riscattare.
          </p>
          <Link to={to} data-testid="landing-gift-cta"
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-primary text-primary-foreground text-sm uppercase tracking-[0.24em] btn-lift">
            <Gift className="w-5 h-5 transition-transform group-hover:-rotate-12" strokeWidth={1.6} />
            Scopri tutte le opzioni regalo
          </Link>
        </div>
      </div>
    </section>
  );
}
